import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { AbstractService } from "../../abstractions/abstract-typed.service";
import { Globals } from "../../app.globals";

@Injectable()
export class OrganizationsService extends AbstractService<Organization> {
    private apiUrl = "/api/settings/Organizations";

    constructor(public http: HttpClient, public globals: Globals) {
        super(http, globals);
    }

    getOrganizationsForRfi(
        projectId: number,
        entryNumber: number
    ): Observable<Organization[]> {
        this.showSpinner();
        return this.http
            .get(this.apiUrl + "/getall/" + projectId + "/rfi/" + entryNumber)
            .pipe(
                map((res) => res as Organization[]),
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            );
    }

    getOrganizationsForDaywork(
        projectId: number,
        entryNumber: number
    ): Observable<Organization[]> {
        this.showSpinner();
        return this.http
            .get(
                this.apiUrl + "/getall/" + projectId + "/daywork/" + entryNumber
            )
            .pipe(
                map((res) => res as Organization[]),
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            );
    }

    getOrganizationsForCvi(
        projectId: number,
        entryNumber: number
    ): Observable<Organization[]> {
        this.showSpinner();
        return this.http
            .get(this.apiUrl + "/getall/" + projectId + "/cvi/" + entryNumber)
            .pipe(
                map((res) => res as Organization[]),
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            );
    }

    getOrganizationsForSubmittal(
        projectId: number,
        entryNumber: number
    ): Observable<Organization[]> {
        this.showSpinner();
        return this.http
            .get(
                this.apiUrl +
                    "/getall/" +
                    projectId +
                    "/submittal/" +
                    entryNumber
            )
            .pipe(
                map((res) => res as Organization[]),
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            );
    }

    getTypes(): Observable<Lookup[]> {
        this.showSpinner();
        return this.http.get(this.apiUrl + "/getalltypes").pipe(
            map((res) => res as Lookup[]),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    uploadFile(formData: FormData): Observable<any> {
        this.showSpinner();
        return this.http.put(this.apiUrl + "/upload", formData).pipe(
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    getDisciplines(): Observable<Lookup[]> {
        this.showSpinner();
        return this.http.get(this.apiUrl + "/getalldisciplines").pipe(
            map((res) => res as Lookup[]),
            catchError(this.handleError),
            finalize(() => this.hideSpinner())
        );
    }

    getApiUrl(): string {
        return this.apiUrl;
    }
}

export class Organization {
    id: number;
    name: string;
    address: string;
    postalCode: string;
    city: string;
    province: string;
    country: string;
    type: string;
    discipline: string;

    static map(entity: any): Organization {
        return {
            address: entity.address,
            id: entity.id,
            name: entity.name,
            postalCode: entity.postalCode,
            city: entity.city,
            province: entity.province,
            country: entity.country,
            type: entity.type,
            discipline: entity.discipline,
        };
    }
}

class Lookup {
    value: string;
    label: string;
}
